














export default {
    name: 'CompanyVerificationPanel',

    computed: {
        companyIsVerified() {
            return Boolean(this.$auth.user?.company.status !== 'pending_verification');
        },
    },
};
